export default __webpack_public_path__ + "static/rearrange_image-4da9ede12b4fa475db0e91c0bada12dc.gif";